module.exports = __webpack_public_path__ + "img/occupied_car.3453f456.svg";